import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { openNextQuest } from 'a/hub/actions/workshopActions';
import useWorkshopSfx from '../../../hooks/useWorkshopSfx';
import BackgroundSvg from './svgs/BackgroundSmall.svg';
import BurstSvg from './svgs/Burst.svg';
import MonsterIconSvg from './svgs/MonsterIcon.svg';
import {
  StaticBurst, ContinueButton, Background, MonsterIcon, Title,
  TitleTextContainer, DescriptionContainer, Description, QuestionContainer, Question,
} from './styledComponents';
import { ModalContainer } from '../sharedComponents';

const titleText = 'NEW';

const descriptionText = 'All Quests Complete!';

const questionText = 'But your journey as a reader is never done. You have now unlocked' +
' the CHALLENGE ROUNDS! Click on the portal in the workshop to play.';

const EndOfQuestsModal = ({ closeModal }) => {
  const dispatch = useDispatch();

  const { playTap, playSfxFromMap, audioMap } = useWorkshopSfx();

  useEffect(() => {
    playSfxFromMap(audioMap.all_quests_complete_launch);
  }, []);

  const handleClick = () => {
    playTap(true);
    dispatch(openNextQuest());
    closeModal();
  };

  return (
    <ModalContainer
      role="dialog"
      aria-modal="true"
      aria-labelledby="end-quests-modal-title"
      data-testid="all-quests-complete-modal"
      data-dd-action-name="workshop-end-of-quests-modal"
    >
      <Background src={BackgroundSvg} alt="" />
      <StaticBurst src={BurstSvg} alt="" />
      <MonsterIcon data-testid="all-quests-complete-modal-image" src={MonsterIconSvg} alt="" />
      <TitleTextContainer>
        <Title
          id="end-quests-modal-title"
          data-testid="all-quests-complete-modal-title"
        >
          {titleText}
        </Title>
      </TitleTextContainer>
      <DescriptionContainer>
        <Description
          data-testid="all-quests-complete-modal-description"
        >
          {descriptionText}
        </Description>
      </DescriptionContainer>
      <QuestionContainer data-testid="all-quests-complete-modal-message">
        <Question>{questionText}</Question>
      </QuestionContainer>
      <ContinueButton
        onClick={handleClick}
        data-testid="all-quests-complete-modal-continue-button"
        data-dd-action-name="workshop-end-of-quests-modal:continue"
      >
        Continue
      </ContinueButton>
    </ModalContainer>
  );
};

export default EndOfQuestsModal;

EndOfQuestsModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
};
